import { EmployeeFormValues } from "../common/EmployeeFormValues";
import { EmployerFormValues } from "../common/EmployerFormValues";
import { PhysicianFormValues } from "../common/PhysicianFormValues";
import { BeneficiaryFormValues } from "../common/BeneficiaryFormValues";
import { PaymentPreference } from "./PaymentPreference";
import { PfmlEmployerFormValues } from "../pfml/PfmlEmployerFormValues";
import { LifeBeneficiaryFormValues } from "../life/LifeBeneficiaryFormValues";
import EftModal from "../structure/EftModal";
import FraudModal from "../structure/FraudModal";
import { ReactElement } from "react";
import SubstituteW9Modal from "../structure/SubstituteW9Modal";
import EmployerReimbursementModal from "../structure/EmployerReimbursementModal";
import _ from "lodash";
import { DisabilityEmployeeFormValues } from "../disability/DisabilityEmployeeFormValues";

export enum Agreement {
    ELECTRONIC_FUNDS_TRANSFER_AUTHORIZATION = "Authorization agreement for electronic funds transfer",
    EMPLOYER_REIMBURSEMENT = "Employer reimbursement policyholder responsibilities",
    FRAUD_NOTICE_REQUIREMENTS = "Fraud notice requirements",
    HIPAA_AUTHORIZATION = "HIPAA authorization",
    SUBSTITUTE_W9 = 'Request for taxpayer identification number and certification (Substitute W-9)'
}

export namespace Agreement {
    const agreementIdByAgreement = new Map([
        [Agreement.ELECTRONIC_FUNDS_TRANSFER_AUTHORIZATION, 'eft-consent'],
        [Agreement.EMPLOYER_REIMBURSEMENT, 'employer-reimbursement-consent'],
        [Agreement.FRAUD_NOTICE_REQUIREMENTS, 'fraud-consent'],
        [Agreement.HIPAA_AUTHORIZATION, 'hipaa-consent'],
        [Agreement.SUBSTITUTE_W9, 'tax-payer-disclaimer-acknowledged']
    ])

    const agreementModalByAgreement = new Map<Agreement, (props: any) => ReactElement | null>([
        [Agreement.ELECTRONIC_FUNDS_TRANSFER_AUTHORIZATION, EftModal],
        [Agreement.EMPLOYER_REIMBURSEMENT, EmployerReimbursementModal],
        [Agreement.FRAUD_NOTICE_REQUIREMENTS, FraudModal],
        [Agreement.SUBSTITUTE_W9, SubstituteW9Modal],
    ])

    export function isSignatureRequired(agreement: Agreement) {
        return [Agreement.EMPLOYER_REIMBURSEMENT, Agreement.HIPAA_AUTHORIZATION, Agreement.SUBSTITUTE_W9].includes(agreement)
    }

    export function findAgreementsFor(initialValues: EmployeeFormValues | EmployerFormValues | PhysicianFormValues | BeneficiaryFormValues,
                                      values: EmployeeFormValues | EmployerFormValues | PhysicianFormValues | BeneficiaryFormValues): Agreement[] {
        let agreements = [];
        const requestsEmployerReimbursement = 'Yes' === (values as PfmlEmployerFormValues).employerReimbursement;
        if(requestsEmployerReimbursement) {
            agreements.push(Agreement.EMPLOYER_REIMBURSEMENT)
        }
        if((values as EmployeeFormValues).paymentPreference === PaymentPreference.EFT
            || (requestsEmployerReimbursement && (values as PfmlEmployerFormValues).employerPaymentPreference === PaymentPreference.EFT)) {
            agreements.push(Agreement.ELECTRONIC_FUNDS_TRANSFER_AUTHORIZATION)
        }
        if((initialValues as DisabilityEmployeeFormValues).hipaaConsent !== undefined) {
            agreements.push(Agreement.HIPAA_AUTHORIZATION)
        }
        if('No' === (values as LifeBeneficiaryFormValues).hasBackupWithholding) {
            agreements.push(Agreement.SUBSTITUTE_W9)
        }
        if((initialValues as EmployeeFormValues).fraudConsent !== undefined) {
            agreements.push(Agreement.FRAUD_NOTICE_REQUIREMENTS)
        }
        return agreements
    }

    export function findAgreementIdFor(agreement: Agreement) {
        return agreementIdByAgreement.get(agreement) ?? ''
    }

    export function findModalFor(agreement: Agreement): (props: any) => ReactElement | null {
        return agreementModalByAgreement.get(agreement) as (props: any) => ReactElement | null
    }

    export function findAgreementNameFor(agreement: Agreement) {
        return _.camelCase(findAgreementIdFor(agreement))
    }
}
